/** Which slice of the publish history the processing grid shows. */
export const PublishScope = {
  /** This client's own runs. Named for the client, not the parent, since a standalone client has one too. */
  Client: 'client',
  /** Publish-all runs, grouped under the batch that started them. */
  Batches: 'batches',
  /** Runs belonging to the clients rolling up to this one. */
  Children: 'children',
} as const;

export type PublishScope = (typeof PublishScope)[keyof typeof PublishScope];

export const PUBLISH_SCOPE_ORDER: PublishScope[] = [
  PublishScope.Client,
  PublishScope.Batches,
  PublishScope.Children,
];

export const PUBLISH_SCOPE_LABEL: Record<PublishScope, string> = {
  [PublishScope.Client]: 'Client',
  [PublishScope.Batches]: 'Batches',
  [PublishScope.Children]: 'Children',
};

/** The path a scope's history lives at, so a refresh or a shared link lands back on it. */
export const PAM_PROCESSING_BASE_PATH = '/pam/processing';

/** Narrows a URL segment to a scope the page knows. */
export function isPublishScope(value: unknown): value is PublishScope {
  return typeof value === 'string' && (PUBLISH_SCOPE_ORDER as readonly string[]).includes(value);
}
